export default "__VITE_ASSET__9e7b8742__"